(function () {
  function init() {
    var modal  = document.getElementById('csm-modal');
    if (!modal) return;

    var close  = document.getElementById('csm-close');
    var skip   = document.getElementById('csm-skip');
    var addBtn = document.getElementById('csm-add');
    var addTxt = document.getElementById('csm-add-txt');
    var loader = document.getElementById('csm-loader');
    var items  = modal.querySelectorAll('.csm-item');

    /* ── Toggle selection ── */
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        item.classList.toggle('sel');
        updateButton();
      });
    });

    function updateButton() {
      var count = modal.querySelectorAll('.csm-item.sel').length;
      addTxt.textContent = count ? 'Add ' + count + ' to Cart' : 'Add to Cart';
      addBtn.disabled = (count === 0);
    }
    updateButton();

    /* ── Open / Close ── */
    function openModal() {
      modal.classList.add('show');
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    close.addEventListener('click', closeModal);
    skip.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    /* ── Intercept Dawn's add-to-cart fetch ── */
    var _originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
      var opts = args[1] || {};
      var method = (opts.method || 'GET').toUpperCase();

      if (url.indexOf('/cart/add') !== -1 && method === 'POST') {
        return _originalFetch.apply(this, args).then(function(response) {
          if (!window.__csmAddingAddons && response.ok) {
            setTimeout(openModal, 400);
          }
          return response;
        });
      }

      return _originalFetch.apply(this, args);
    };

    /* ── Add selected add-ons to cart ── */
    addBtn.addEventListener('click', function() {
      var selected = modal.querySelectorAll('.csm-item.sel');
      if (!selected.length) return;

      addBtn.disabled = true;
      addTxt.style.display = 'none';
      loader.style.display = 'inline-block';

      /* Build form data — Shopify is more reliable with this format */
      var formData = new FormData();
      var i = 0;
      selected.forEach(function(el) {
        formData.append('items[' + i + '][id]', el.dataset.vid);
        formData.append('items[' + i + '][quantity]', '1');
        i++;
      });

      /* Flag so our interceptor doesn't re-open the modal */
      window.__csmAddingAddons = true;

      _originalFetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) {
        window.__csmAddingAddons = false;
        if (!res.ok) {
          return res.json().then(function(err) {
            throw new Error(err.description || 'Cart error');
          });
        }
        return res.json();
      })
      .then(function() {
        /* Update cart count in header */
        return _originalFetch('/cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span');
        bubbles.forEach(function(el) { el.textContent = cart.item_count; });
        /* Show bubble if it was hidden */
        var bubble = document.querySelector('.cart-count-bubble');
        if (bubble) bubble.classList.remove('hidden');
        closeModal();
      })
      .catch(function(err) {
        window.__csmAddingAddons = false;
        console.error('Add-on cart error:', err);
        alert('Could not add items: ' + err.message);
      })
      .finally(function() {
        addBtn.disabled = false;
        addTxt.style.display = '';
        loader.style.display = 'none';
      });
    });

    console.log('[CSM] Add-ons modal initialized ✓');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();